<template>
  <div class="w-full max-w-sm font-proxima bg-white shadow-sm ring-1 ring-black ring-opacity-5 rounded-sm">
    <div class="px-4 py-2 bg-red-50 border-b border-gray-300">
      <p class="text-sm font-bold text-black">Funding Source Snapshot</p>
    </div>
    <div class="px-4 py-3">
      <p class="text-xs text-gray-500">Unspent Balance (remaining)</p>
      <p class="text-2xl font-bold text-black">{{ money(output?.unspentBalanceUsd) }}</p>
      <dl class="mt-3 divide-y divide-gray-200">
        <div v-for="line in lines" :key="line.label" class="flex justify-between py-1.5 text-sm">
          <dt class="text-gray-600">{{ line.label }}</dt>
          <dd class="text-black">{{ money(line.value) }}</dd>
        </div>
      </dl>
    </div>
  </div>
</template>
<script setup lang="ts">
interface FundingSourceSnapshot {
  initialAwardUsd?: number;
  awardAdjustmentsUsd?: number;
  currentAwardUsd?: number;
  fundAllocationUsd?: number;
  unallocatedUsd?: number;
  totalIssuedPaymentsUsd?: number;
  totalPendingPaymentsUsd?: number;
  currentBalanceOfFundsUsd?: number;
  unspentBalanceOfFundsUsd?: number;
  unspentBalanceUsd?: number;
}

const props = defineProps<{ part: { output?: FundingSourceSnapshot } }>();

const output = computed(() => props.part.output);

// Values arrive pre-converted to dollars (see get_funding_source_ledger_snapshot selectResult)
const money = (usd?: number) => (usd == null ? '—' : formatNumberToMoney(usd));

const lines = computed(() => [
  { label: 'Current Award', value: output.value?.currentAwardUsd },
  { label: 'Allocated into Funds', value: output.value?.fundAllocationUsd },
  { label: 'Unallocated', value: output.value?.unallocatedUsd },
  { label: 'Issued Payments', value: output.value?.totalIssuedPaymentsUsd },
  { label: 'Pending Payments', value: output.value?.totalPendingPaymentsUsd },
  { label: 'Current Balance of Funds', value: output.value?.currentBalanceOfFundsUsd },
]);
</script>
